export default __webpack_public_path__ + "static/media/Digital_content_website_icon_01.c31f8a02.svg";